import { contexts } from '@/domains'
import { Avatar, Space, Tooltip } from 'antd'
import { observer } from 'mobx-react-lite' 
import AvatarWithBadge from '../AvatarWithBadge/AvatarWithBadge';
type Props = {
  id: string 
  effect: 'post' | 'leader' | null
  showName?:boolean
}
const { UserContext } = contexts

const UserIcon = (props: Props) => {
  const { id, effect, showName = false } = props
  const { userRecord } = UserContext.useContainer()
  const userItem = userRecord[id]
  const { userAvatar, userName } = userItem || {}
  const avatarEl = <Avatar size={28} src={userAvatar} />
  return (
    <Space className="user-brief" direction='horizontal' size={0}> 
        <AvatarWithBadge badge={effect} avatar={avatarEl} userName={userName}/> 
        <span>{showName? userName : ''}</span>
    </Space>
  )
}

export default observer(UserIcon)
